(function () {
  'use strict';

  app.service('classificationDetailsService', service);

  function service() {
    this.validate = function (details, isAmountOptional) {
      var errors = false;
      if (details && 'transactionDetails' in details) {
        // eslint-disable-next-line no-param-reassign
        details = details.transactionDetails;
      }
      _.each(details, function (detail) {
        detail.errors = detail.errors || {};
        detail.errors.amount = validateAmount(detail, isAmountOptional);
        detail.errors.classification = validateClassification(detail);

        if (detail.errors.amount || detail.errors.classification) errors = true;
        else delete(detail.errors);
      });

      return !errors;
    };

    function validateAmount(detail, isAmountOptional) {
      var maxAmount = 1000000;
      if (detail.amount > maxAmount) {
        return 'Amount should be less than $1,000,000.00';
      } else if ((!detail.amount && !isAmountOptional) && detail.classification && detail.classification.caption) {
        return 'Amount should be greater than $0.00';
      }
    }

    function validateClassification(detail) {
      if (detail.classification && detail.classification.id) {
        return;
      } else if (detail.classification && detail.classification.caption) {
        return 'There is no classification with this name. Please select one from the dropdown';
      } else if ((!detail.classification || !detail.classification.caption) && detail.amount) {
        return 'Please select classification';
      }
    }

    this.getDetailsWithData = function (details) {
      return _.filter(details, function (item) {
        return item.classification && item.classification.caption || item.amount;
      });
    };
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/classificationDetails/service.js